
import { mapMutations } from 'vuex';
import EventBus from '../events';
import { validateAccess } from '../libs/helpers';
import IDKITApi from '../libs/IDKITApi';
import _const from '../const';
import Reception from '../components/ReceptionComponent.vue';
import ERROR_MESSAGES from '../libs/errorMessages';

import '../styles/theme-seat.scss';
import '../styles/seaticons.scss';

export default {
  name: 'SeatLayout',
  components: { Reception },
  data() {
    return {
      isExpandedInformation: false,
      isExpandedContact: false,
      confirmLogout: false,
      isChecklistEnabled: false,
      isPaymentEnabled: false,
      sessionTimer: null,
      statusInvoice: null,
      termsConditionsAndPrivacyShowing: false,
      logoutError: '',
    };
  },
  computed: {
    desktop() {
      return this.$q.screen.gt.md;
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    narrowScreen() {
      return this.$q.screen.width < 350;
    },
    isInvoiceEnabled() {
      return validateAccess(_const.MODULE_INVOICES);
    },
  },
  created() {
    this.updateTermsConditionsAndPrivacyShowing();
    EventBus.$on('privacy-updated', this.updateTermsConditionsAndPrivacyShowing);
  },
  mounted() {
    this.changeViewsEnabled();
    this.initialCharge();
  },
  beforeDestroy() {
    EventBus.$off('privacy-updated', this.updateTermsConditionsAndPrivacyShowing);
  },
  methods: {
    ...mapMutations('Tutorial', ['SET_ACTIVATE_TUTORIAL']),
    updateTermsConditionsAndPrivacyShowing() {
      this.termsConditionsAndPrivacyShowing = this.checkTermsAccepted;
    },
    initialCharge() {
      EventBus.$on('validateViews', this.changeViewsEnabled);
      EventBus.$on('setSessionToken', this.setTimeoutToken);
      // Iniciamos el timer para actualizar el token de sesión
      if (!this.$session.get('isInternal')) this.initSessionTokenTimer();
    },
    initSessionTokenTimer() {
      // Para sacar el tiempo restante del timer nos basamos en la fecha de expiración del token
      /* De ahí contamos a partir de la fecha actual
      cuantos ms le restan, esto para que contemos aún si refrescan la página */
      const nowTime = this.moment();
      const expireTime = this.moment.duration(this.moment(this.$session.get('expire_date')).diff(nowTime));
      const time = expireTime.asMinutes() * 60000;
      // Iniciamos el timer y una vez que finalice ejecutamos la función de actualizar token
      this.sessionTimer = setTimeout(() => {
        this.updateIDKITToken();
      }, time);
    },
    async updateIDKITToken() {
      try {
        // Obtenemos el token nuevo
        const tokenData = await IDKITApi.updateSessionToken(this.$session.get('state'));
        // Reseteamos el timer del token
        this.setTimeoutToken(tokenData);
      } catch (error) {
        this.alertShow(this.validateResponseErrorMessage(error), 'error');
      }
    },
    setTimeoutToken(tokenData) {
      // Eliminamos el timer
      clearTimeout(this.sessionTimer);
      // Seteamos los nuevo token en sesión, esta función viene del startup
      this.setSessionToken(tokenData);
      // Iniciamos nuevamente el proceso del timer
      this.initSessionTokenTimer();
    },
    activateTutorial() {
      this.SET_ACTIVATE_TUTORIAL(true);
    },
    changeViewsEnabled() {
      this.isChecklistEnabled = validateAccess(_const.MODULE_ADDITIONAL_BUDGETS);
      this.isPaymentEnabled = validateAccess(_const.MODULE_PAYMENT);
    },
    async logout() {
      this.loaderShow('Cerrando sesión');
      this.logoutError = '';

      try {
        this.logOutLogic();
      } catch (error) {
        this.logoutError = ERROR_MESSAGES.ACTION;
      } finally {
        this.loaderHide();
      }
    },
    selectMenuSection(section) {
      return this.$route.name === section ? 'menu-active' : 'menu-inactive';
    },
    scrollHandler(details) {
      const header = this.$refs.header && this.$refs.header.$el;

      if (!header) return;

      if (details.position > 0) {
        header.classList.add('adc-header-transparent');
        header.classList.remove('absolute-top');
        header.classList.add('fixed-top');
      } else {
        header.classList.remove('adc-header-transparent');
        header.classList.add('absolute-top');
        header.classList.remove('fixed-top');
      }
    },
  },
};
